<template>
  <div class="mask" v-if="isShow">
    <div class="container">
      <div
        class="container_l"
        @mouseenter="stopAutoSlide"
        @mouseleave="startAutoSlide"
      >
        <div class="img_content">
          <template v-for="(item, index) in info.files">
            <img
              v-if="getFileType(item.path) !== 'video'"
              :src="item.path"
              class="big_img"
              :key="'img_' + index"
              :style="{
                opacity: currentImg == index ? 1 : 0,
                pointerEvents: currentImg == index ? 'auto' : 'none',
              }"
            />
            <video
              v-else
              :src="item.path"
              class="big_img"
              :key="'vid_' + index"
              :ref="'video_' + index"
              controls
              :style="{
                opacity: currentImg == index ? 1 : 0,
                pointerEvents: currentImg == index ? 'auto' : 'none',
              }"
            />
          </template>
        </div>
        <div class="footer">
          <div class="footer_btn_l" @click="changeSlide('left')">←</div>
          <div class="footer_content" ref="footerContent">
            <template v-for="(item, index) in info.files">
              <img
                v-if="getFileType(item.path) !== 'video'"
                ref="imgItem"
                :class="index == currentImg ? 'img_active' : ''"
                v-lazy="item.path"
                :style="{ transform: `translateX(${translateX}px)` }"
                :key="'fimg_' + index"
                @mousemove="changeCurrentImg(index)"
              />
              <video
                v-else
                :class="index == currentImg ? 'img_active' : ''"
                :src="item.path"
                muted
                preload="metadata"
                :style="{ transform: `translateX(${translateX}px)` }"
                :key="'fvid_' + index"
                @mousemove="changeCurrentImg(index)"
              />
            </template>
          </div>
          <div class="footer_btn_r" @click="changeSlide('right')">→</div>
        </div>
      </div>
      <div class="container_r">
        <div class="title">{{ info.fx_name }}</div>
        <div class="square">
          <span>{{ info.acreage_min }}-{{ info.acreage_max }}㎡</span>
          <span>|</span>
          <span>{{ info.rental_type == 1 ? "整租" : "合租" }}</span>
        </div>
        <div class="square" v-if="info.building_name">
          <span>{{ info.building_name }}</span>
        </div>
        <div class="price">
          <span class="count">{{ info.price_min }}-{{ info.price_max }}</span>
          <span class="unit">元/月</span>
        </div>
        <div class="tag">
          <div
            class="tag_item"
            v-for="(item, index) in info.appliances"
            :key="index"
          >
            {{ item.bq_name }}
          </div>
        </div>
        <div class="subtitle" v-if="info.brief_info">房源描述</div>
        <div class="content" :title="info.brief_info">
          {{ info.brief_info }}
        </div>
        <div class="btn_div">
          <img src="../../assets/image/dh.png" />
          电话预约：4001883001
          <!-- {{ info.booking_advice_info?.booking_line }} -->
        </div>
        <div class="btn_div yuyue">
          预约看房
          <div style="position: relative">
            <div class="qr_code">
              <!-- <img
                :src="info.booking_advice_info?.qrcode?.src"
                :title="info.booking_advice_info?.qrcode?.title"
              /> -->
              <img src="@/assets/image/ewm.png" title="预约二维码" />
              <span>手机扫一扫上方二维码，预约看房</span>
            </div>
          </div>
        </div>
        <div
          v-if="
            info.config &&
            info.config.other_expenses &&
            info.config.other_expenses.length
          "
        >
          <div class="subtitle">费用信息</div>
          <div class="cost">
            <div
              v-for="(item, index) in info.config.other_expenses"
              :key="index"
            >
              {{ item.name }}：{{ item.value }}
              <span v-if="item.name == '管理费'">元</span>
              <span v-else-if="item.name == '水费'">元/吨</span>
              <span v-else-if="item.name == '电费'">元/度</span>
              <span v-else-if="item.name == '网络费'">元/月</span>
            </div>
          </div>
        </div>
        <div class="subtitle">房型配置</div>
        <div class="icon_list">
          <div
            class="icon_list_item"
            v-for="(item, index) in filesList"
            :key="index"
          >
            <img :src="item.value" />
            <span>{{ item.label }}</span>
          </div>
        </div>
      </div>
      <div class="container_pro">
        <div class="container_pro_title">常见问题</div>
        <div class="container_pro_list" v-if="contentList.length">
          <div
            class="container_pro_item"
            v-for="(item, index) in contentList"
            :key="index"
          >
            <div class="container_pro_item_t">
              <img src="@/assets/image/wen@2x.png" alt="" />
              <span>{{ item.title }}</span>
            </div>
            <div class="container_pro_item_b">
              <img src="@/assets/image/da@2x.png" alt="" />
              <span>{{ item.content }}</span>
            </div>
          </div>
        </div>
        <div class="container_pro_empty" v-else>
          <div class="empty_icon">?</div>
          <div class="empty_title">暂无问题</div>
          <div class="empty_desc">该房型暂时没有常见问题内容</div>
        </div>
      </div>
      <!-- 关闭按钮 -->
      <img src="../../assets/image/gb.png" class="close" @click="closeDialog" />
    </div>
    <small-loading v-if="isLoading" />
  </div>
</template>
<script>
import smallLoading from "@/components/loading/smallLoading.vue";
import { getHouseDetail, qaLists } from "@/api/lookHouse";
export default {
  components: {
    smallLoading,
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isShow(n) {
      if (n) {
        this.stop();
        this.currentImg = 0;
        this.executeAnimation();
      } else {
        this.move();
      }
    },
  },
  data() {
    return {
      translateX: 0,
      current: 0,
      currentImg: 0,
      iconList: [
        { icon: "chuang", name: "床" },
        { icon: "rsq", name: "热水器" },
        { icon: "bx", name: "冰箱" },
        { icon: "xyj", name: "洗衣机" },
        { icon: "yyj", name: "油烟机" },
        { icon: "sf", name: "沙发" },
        { icon: "kt", name: "空调" },
        { icon: "yz", name: "餐椅" },
        { icon: "xg", name: "鞋柜" },
        { icon: "czg", name: "餐桌" },
        { icon: "yg", name: "衣柜" },
        { icon: "wbl", name: "微波炉" },
      ],
      detailId: null,
      info: {},
      filesList: [],
      isLoading: false,
      timer: {},
      contentList: [],
    };
  },
  methods: {
    initPageData() {
      this.isLoading = true;
      Promise.all([this.initData(), this.initContent()]).then((_) => {
        this.isLoading = false;
      });
    },
    async initData() {
      const { data: res } = await getHouseDetail(this.detailId);
      this.info = res;
      let iconList = [];
      (res.furniture || []).forEach((item) => {
        iconList.push({
          label: item.bq_name,
          value: item.cover_host + item.cover_path,
        });
      });
      this.filesList = iconList;
    },
    initContent() {
      return qaLists({ house_id: this.detailId }).then((res) => {
        this.contentList = res.data || [];
      });
    },
    stop() {
      let mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", mo, false); //禁止页面滑动
    },
    move() {
      let mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    },
    closeDialog() {
      this.$parent.isShow = false;
    },
    changeSlide(type) {
      this.pauseCurrentVideo();
      let width = this.$refs.imgItem[0]?.offsetWidth || 0;
      let border = "";
      if (this.$refs.footerContent) {
        border = window
          .getComputedStyle(this.$refs.footerContent)
          .columnGap.split("px")[0];
      }
      //元素移动的距离
      let distance = width + Number(border);
      this.executeAnimation();
      if (type == "left") {
        if (this.currentImg == 0) {
          this.currentImg = this.info?.files?.length - 1;
          this.translateX = (this.info?.files?.length - 4) * distance * -1;
        } else {
          this.currentImg = this.currentImg - 1;
          if (this.currentImg > 2) {
            this.translateX = this.translateX + distance;
          }
        }
      } else if (type == "right") {
        if (this.currentImg == this.info?.files?.length - 1) {
          this.currentImg = 0;
        } else {
          this.currentImg = this.currentImg + 1;
        }
        //滑动
        if (this.currentImg > 3) {
          this.translateX = this.translateX - distance;
        } else {
          this.translateX = 0;
        }
      }
    },
    getFileType(path) {
      const videoExts = [
        "mp4",
        "webm",
        "ogg",
        "mov",
        "avi",
        "flv",
        "mkv",
        "wmv",
      ];
      const ext = String(path).split(".").pop().toLowerCase();
      return videoExts.includes(ext) ? "video" : "image";
    },
    pauseCurrentVideo() {
      const refKey = "video_" + this.currentImg;
      const videoRef = this.$refs[refKey];
      const el = Array.isArray(videoRef) ? videoRef[0] : videoRef;
      if (el && typeof el.pause === "function") {
        el.pause();
      }
    },
    changeCurrentImg(i) {
      if (this.currentImg !== i) {
        this.pauseCurrentVideo();
      }
      this.currentImg = i;
    },
    executeAnimation() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.changeSlide("right");
      }, 3000);
    },
    stopAutoSlide() {
      clearInterval(this.timer);
    },
    startAutoSlide() {
      this.executeAnimation();
    },
  },
};
</script>
<style scoped lang="scss">
.img_active {
  border: 2px solid #ffa71d;
  box-sizing: border-box;
}
.mask {
  position: fixed;
  inset: 0;
  z-index: 999;
  width: 100vw;
  height: 100vh;
  background-color: rgba($color: #000000, $alpha: 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  .container {
    width: 1400px;
    height: 632px;
    padding: 20px;
    box-sizing: border-box;
    background-color: #fff;
    position: relative;
    display: flex;
    column-gap: 20px;
    .close {
      width: 50px;
      height: 50px;
      position: absolute;
      top: -54px;
      right: -54px;
      cursor: pointer;
    }
    &_l {
      width: 667px;
      height: 100%;
      display: flex;
      flex-direction: column;
      row-gap: 18px;
      .img_content {
        width: 100%;
        height: 472px;
        overflow: hidden;
        position: relative;
        .big_img {
          width: 100%;
          height: 100% !important;
          object-fit: cover;
          position: absolute;
          inset: 0;
          transition: all 1s ease;
        }
      }
      .footer {
        display: flex;
        column-gap: 20px;
        &_content {
          flex: 1;
          overflow: hidden;
          display: flex;
          column-gap: 19px;
          img,
          video {
            min-width: 125px;
            max-width: 125px;
            height: 100px;
            object-fit: cover;
            cursor: pointer;
            transition: all 0.3s ease;
          }
        }
        &_btn_l,
        &_btn_r {
          width: 35px;
          height: 100px;
          background: #ffa71d;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          -webkit-user-select: none; /* Safari */
          -moz-user-select: none; /* Firefox */
          -ms-user-select: none; /* IE 10+/Edge */
          user-select: none;
        }
      }
    }
    &_r {
      width: 333px;
      height: 100%;
      color: #333333;
      .title {
        font-size: 22px;
        font-weight: bold;
      }
      .subtitle {
        font-size: 18px;
        font-weight: bold;
      }
      .square {
        color: #666666;
        font-size: 14px;
        margin: 10px 0;
        display: flex;
        column-gap: 10px;
        align-items: center;
      }
      .price {
        .count {
          color: #ff4d4d;
          font-size: 22px;
          font-weight: bold;
        }
        .unit {
          font-size: 14px;
        }
      }
      .tag {
        display: flex;
        column-gap: 10px;
        flex-wrap: wrap;
        row-gap: 5px;
        margin-top: 5px;
        margin-bottom: 10px;
        &_item {
          padding: 3px 5px;
          box-sizing: border-box;
          background: #f4f4f4;
          border: 1px solid #d9d9d9;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          flex-shrink: 0;
        }
      }
      .content {
        font-size: 12px;
        text-indent: 2em;
        line-height: 18px;
        margin: 10px 0;

        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .btn_div {
        width: 100%;
        height: 40px;
        background: #999999;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        column-gap: 10px;
        border-radius: 4px;
        margin: 10px 0;
        position: relative;
        img {
          width: 18px;
          height: 18px;
        }
        .qr_code {
          width: 250px;
          height: 250px;
          padding: 20px 20px 34px 20px;
          box-sizing: border-box;
          background-color: #fff;
          position: absolute;
          bottom: 42px;
          left: 50%;
          z-index: 9999999;
          display: none;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          span {
            font-size: 14px;
            color: #666666;
            display: block;
            white-space: nowrap; /* 防止文本换行 */
            overflow: hidden; /* 溢出部分隐藏 */
            text-overflow: ellipsis; /* 超出部分显示省略号 */
          }
          &::after {
            content: "";
            display: block;
            width: 0;
            height: 0;
            border-top: 10px solid #fff;
            border-bottom: 14px solid transparent;
            border-right: 10px solid transparent;
            border-left: 10px solid transparent;
            position: absolute;
            bottom: -22px;
            left: 10%;
          }
        }
      }
      .yuyue {
        background: #ffa71d;

        &:hover {
          .qr_code {
            display: block;
          }
        }
      }
      .cost {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;
        grid-gap: 10px;
        font-size: 12px;
        color: #666;
        margin: 10px 0;
      }
      .icon_list {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 20px;
        color: #666;
        margin-top: 10px;
        &_item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          img {
            width: 30px;
            height: 30px;
          }
        }
      }
    }
    &_pro {
      flex: 1;
      height: 100%;
      border-left: 1px solid #eee;
      padding: 0 0 0 20px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      &_title {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        margin-bottom: 16px;
      }
      &_list {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: scroll;
        -ms-overflow-style: none;
        scrollbar-width: none;
        &::-webkit-scrollbar {
          display: none;
        }
      }
      &_item {
        width: 100%;
        background: #f5f5f5;
        border-radius: 4px;
        padding: 16px;
        box-sizing: border-box;
        margin-bottom: 10px;
        img {
          width: 20px;
          height: 20px;
        }
        &_t {
          display: flex;
          align-items: center;
          column-gap: 10px;
          margin-bottom: 15px;
          span {
            font-size: 18px;
            font-weight: bold;
            color: #333333;
          }
        }
        &_b {
          display: flex;
          column-gap: 10px;
          span {
            font-size: 14px;
            color: #666666;
          }
        }
      }
      &_empty {
        flex: 1;
        min-height: 260px;
        background: #f7f7f7;
        border-radius: 6px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #999999;
        .empty_icon {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          background: #ffa71d;
          color: #ffffff;
          font-size: 26px;
          font-weight: bold;
          line-height: 42px;
          text-align: center;
          margin-bottom: 14px;
        }
        .empty_title {
          color: #333333;
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 8px;
        }
        .empty_desc {
          font-size: 13px;
        }
      }
    }
  }
}
</style>
